import {
    INVOICE_HOLDS,
    INVOICE_LINES,
    INVOICE_PAYMENTS,
    INVOICE_SCHEDULED_PAYMENTS,
} from "constants/generalConstants";

/**
 * Stores the fields that are displayed and currency formatting for the
    invoice lines, payments and holds across desktop and mobile.
 * @param {string} contentType 
 * @param {object} invoiceData 
 * @param {boolean} mobile 
 * @returns object
 */
export const contentValues = (contentType, invoiceData, mobile = false) => {
    const mappings = {
        [INVOICE_LINES]: [
            {
                header: "Line Number",
                value: invoiceData?.LINE_NUMBER,
                currency: false,
                mobile: true,
            },
            {
                header: "Line Type",
                value: invoiceData?.LINE_TYPE_DESCRIPTION,
                currency: false,
                mobile: true,
            },
            {
                header: "Line Description",
                value: invoiceData?.DESCRIPTION,
                currency: false,
                mobile: true,
            },
            {
                header: "Quantity Invoiced",
                value: invoiceData?.QUANTITY_INVOICED ?? 0,
                currency: false,
                mobile: true,
            },
            {
                header: "Unit of Measure",
                value: invoiceData?.UNIT_MEAS_LOOKUP_CODE ?? "-",
                currency: false,
                mobile: true,
            },
            {
                header: "Unit Price",
                value: invoiceData?.UNIT_PRICE ?? 0,
                currency: false,
                mobile: true,
            },
            {
                header: "Amount",
                value: invoiceData?.AMOUNT ?? 0,
                currency: true,
                mobile: true,
            },
            {
                header: "Status",
                value: invoiceData?.LINE_STATUS_DISPLAY,
                currency: false,
                mobile: true,
            },
            {
                header: "PO Number",
                value: invoiceData?.PO_NUMBER,
                currency: false,
                mobile: true,
            },
            {
                header: "PO Line",
                value: invoiceData?.PO_LINE_NUMBER,
                currency: false,
                mobile: true,
            },
            {
                header: "PO Shipment",
                value: invoiceData?.SHIPMENT_NUM,
                currency: false,
                mobile: true,
            },
            {
                header: "Buyer",
                value: invoiceData?.BUYER,
                currency: false,
                mobile: true,
            },
        ],
        [INVOICE_PAYMENTS]: [
            {
                header: "Method",
                value: invoiceData?.PAYMENT_METHOD_DISPLAY,
                currency: false,
                mobile: true,
            },
            {
                header: "Payment Date",
                value: invoiceData?.PAYMENT_DATE,
                currency: false,
                mobile: true,
            },
            {
                header: "Payment Reference",
                value: invoiceData?.PAYMENT_REFERENCE,
                currency: false,
                mobile: true,
            },
            {
                header: "Invoice Amount",
                value: invoiceData?.INV_AMOUNT,
                currency: true,
                mobile: true,
            },
            {
                header: "Status",
                value: invoiceData?.PAYMENT_STATUS_DISPLAY,
                currency: false,
                mobile: true,
            },
        ],
        [INVOICE_SCHEDULED_PAYMENTS]: [
            {
                header: "Method",
                value: invoiceData?.PAYMENT_METHOD_DISPLAY,
                currency: false,
                mobile: true,
            },
            {
                header: "Due Date",
                value: invoiceData?.DUE_DATE,
                currency: false,
                mobile: true,
            },
            {
                header: "Invoice Amount",
                value: invoiceData?.GROSS_AMOUNT,
                currency: true,
                mobile: true,
            },
            {
                header: "Remaining Amount",
                value: invoiceData?.REMAINING_AMOUNT,
                currency: true,
                mobile: true,
            },
            {
                header: "Status",
                value:
                    invoiceData?.PAYMENT_STATUS_FLAG == "Y"
                        ? "PAID"
                        : "NOT PAID",
                currency: false,
                mobile: true,
            },
        ],
        [INVOICE_HOLDS]: [
            {
                header: "Hold Name",
                value: invoiceData?.HOLD_NAME_DISP,
                currency: false,
                mobile: true,
            },
            {
                header: "Hold Date",
                value: invoiceData?.HOLD_DATE,
                currency: false,
                mobile: true,
            },
            {
                header: "Hold Reason",
                value: invoiceData?.HOLD_REASON,
                currency: false,
                mobile: true,
            },
            {
                header: "Release Name",
                value: invoiceData?.RELEASE_NAME_DISP
                    ? invoiceData?.RELEASE_NAME_DISP
                    : invoiceData?.RELEASE_LOOKUP_CODE,
                currency: false,
                mobile: true,
            },
            {
                header: "Release Reason",
                value: invoiceData?.RELEASE_REASON,
                currency: false,
                mobile: true,
            },
            {
                header: "Release Date",
                value: invoiceData?.RELEASE_DATE,
                currency: false,
                mobile: true,
            },
        ],
    };

    try {
        if (mobile) {
            return mappings[contentType].filter((data) => data.mobile);
        } else {
            return mappings[contentType];
        }
    } catch {
        return [];
    }
};
